import { useState } from 'react';
import { Fab } from '@material-ui/core';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import { AskAiDrawer } from './AskAiDrawer';
import { useAskAiStyles } from './askAiStyles';
import { useCodebaseConversation } from './useCodebaseConversation';

/**
 * The floating "Ask AI" button, bottom right on every page like a website's
 * chat button. It opens the Ask AI slide-out. Rendered once, in Root, so the
 * conversation it holds survives closing the drawer and changing pages.
 */
export function AskAiLauncher() {
  const classes = useAskAiStyles();
  const [open, setOpen] = useState(false);
  const conversation = useCodebaseConversation();
  return (
    <>
      <Fab
        variant="extended"
        color="primary"
        className={classes.launcher}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        <ChatBubbleOutline aria-hidden />
        Ask AI
      </Fab>
      <AskAiDrawer
        open={open}
        onClose={() => setOpen(false)}
        conversation={conversation}
      />
    </>
  );
}
